import { type SetNPCsProps, type NPC } from 'src/types'

const setNPCs = (dispatch: (arg0: SetNPCsProps) => void, NPCs: Record<string, NPC>) => {
  dispatch({
    type: 'SET_NPCS',
    NPCs
  })
}

export {
  setNPCs
}
